import $ from "jquery";

function setupCategorizedTagControl($category) {
  var changeTagSelect = function () {
    var categoryId = $category.val();
    $("[data-category-id]").attr("disabled", "disabled").hide();
    $('[data-category-id="' + categoryId + '"]')
      .removeAttr("disabled")
      .show();
  };

  changeTagSelect();
  $category.on("change", changeTagSelect);
}

export default setupCategorizedTagControl;
